import { formatLocalDateOnly } from "../../shared utils/dateFormatters.js";

export function isGroupInPeriod(group, period) {
  if (!period) return false;

  return (
    Array.isArray(group.groupDates) &&
    group.groupDates.some((date) => {
      const formattedDate = formatLocalDateOnly(date);
      return (
        formattedDate >= formatLocalDateOnly(period.startDate) &&
        formattedDate <= formatLocalDateOnly(period.endDate)
      );
    })
  );
}

export function enrichStudentsWithGroups(students, groups) {
  return students.map((student) => {
    const matchingGroup = groups.find((g) => g.id === student.group_id);

    return {
      ...student,
      group_name: student.group_name || matchingGroup?.groupName || "",
      adult_full_name:
        student.adult_full_name ||
        (matchingGroup?.leader?.adult
          ? `${matchingGroup.leader.adult.adultName} ${matchingGroup.leader.adult.adultSurname}`
          : ""),
      campus:
        student.campus ||
        matchingGroup?.campus_name ||
        matchingGroup?.campusName ||
        matchingGroup?.campus?.campusName ||
        matchingGroup?.campus?.name ||
        matchingGroup?.campus ||
        "",
      campus_id:
        student.campus_id ??
        student.campusId ??
        matchingGroup?.campus_id ??
        matchingGroup?.campusId ??
        matchingGroup?.campus?.id ??
        "",
    };
  });
}

export function dedupeStudents(students) {
  const seenIds = new Set();
  const deduped = [];

  students.forEach((student) => {
    if (seenIds.has(student.studentId)) {
      console.warn(
        `Duplicate entry detected for student ${student.studentId} (${student.student_name} ${student.student_surname})`
      );
      return;
    }

    seenIds.add(student.studentId);
    deduped.push(student);
  });

  return deduped;
}

export function getTeacherNameFromGroup(group) {
  if (!group?.leader?.adult) return "";
  return `${group.leader.adult.adultName} ${group.leader.adult.adultSurname}`;
}

export function getGroupByFieldValue(classes, field, value) {
  return classes.find((group) => {
    if (field === "group_name") {
      return group.groupName === value;
    }

    if (field === "adult_full_name") {
      return getTeacherNameFromGroup(group) === value;
    }

    return false;
  });
}

export function validateChangedRows({ visibleRows, changes, classes }) {
  return visibleRows.filter((row) => {
    const hasChange = changes.find((c) => c.studentId === row.studentId);

    if (!hasChange) return false;
    if (!row.group_name) return false;

    return !classes.find((g) => g.groupName === row.group_name);
  });
}

export function getCampusId(item) {
  return String(
    item?.campus_id ??
      item?.campusId ??
      item?.campus?.id ??
      ""
  );
}

export function getCampusLabel(item) {
  return String(
    item?.campus_name ??
      item?.campusName ??
      item?.campus?.campusName ??
      item?.campus?.name ??
      item?.campus ??
      ""
  );
}
